import {connect} from 'react-redux';
import * as items from 'items/actions/items';
import {withRouter} from 'react-router';
import React, {Component} from 'react';
import autobind from 'autobind-decorator';
import Loading from './NewItem';
import {Field, Form, Formik} from 'formik';
import {Col, FormGroup, Input, Label} from 'reactstrap';
import {CustomField} from 'apa/components/CustomField';
import {CLASS_CHOICES, TAX_CHOICES, TYPE_CHOICES} from './Item';
import {NavLink} from 'react-router-dom';
import {ItemSchema} from 'items/ItemSchema';
import DeleteItem from 'items/DeleteItem';
import {getEndOfLastMonth} from 'invoices/containers/InvoiceDetail';
import Select from 'react-select';

const itemTemplates = [
    // Kassenbuch
    {
        description: 'Auto-Wäsche',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Auto-Ticket',
        tax_type: 1,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Bewirtung',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Büro-Ausstattung',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Büro-Deko',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Büro-Deko',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Büro-Getränke',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Büro-Reiniger',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Blumen',
        tax_type: 3,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Parken',
        tax_type: 1,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Post',
        tax_type: 1,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Tanken',
        tax_type: 2,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Taxi',
        tax_type: 3,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Verzehr',
        tax_type: 3,
        class_type: 1,
        type: 1,
    },
    {
        description: 'Eigene Einlage',
        tax_type: 1,
        class_type: 4,
        type: 1,
    },
    // Bank
    {
        description: 'Tanken',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Auto Leasing',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Auto-Bedarf',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Auto-Steuer',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Auto-Ticket',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Auto-Versicherung',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Bewirtung',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Büro-Ausstattung',
        tax_type: 3,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Büro-Technik',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Büro-Strom',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Eigene Einlage',
        tax_type: 1,
        class_type: 4,
        type: 0,
    },
    {
        description: 'Einkommsteuer',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Hotelkosten',
        tax_type: 3,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Kontoführung',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Metro 19%',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Metro 7%',
        tax_type: 3,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Miete',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Putzfrau',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Soli',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Spende',
        tax_type: 3,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Staples',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Strato-Domain "sicher-arbeiten"',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Strato-Domain "Sifa-HH"',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Strato-Server',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Umsatzsteuer Vorrausszahlung',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'United Domains',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Versicherung Haftpflicht',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Versicherung-BG',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Versicherung-Krankenkasse',
        tax_type: 1,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Vodafone-Büro',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
    {
        description: 'Vodafone-mobil',
        tax_type: 2,
        class_type: 1,
        type: 0,
    },
]

const itemTemplatesByType = [
    [], [],
]
itemTemplates.map(
    template => itemTemplatesByType[template.type].push(template)
)

@connect(
    state => (
        {
            items: state.items
        }
    ),
    dispatch => (
        {
            add: (item, history) => dispatch(items.add(item, history)),
            update: (item_id, history) => dispatch(items.update(item_id, history))
        }
    )
)
@withRouter
export class ItemDetail extends Component {
    constructor(props) {
        super(props);
        if (!props.item) {
            const currentType = this.props.items.currentType > -1 ? this.props.items.currentType : 0;
            this.state = {
                isNew: true,
                isLoading: false,
                item: {
                    templates: itemTemplates[currentType],
                    date: getEndOfLastMonth(),
                    description: '',
                    amount: '',
                    type: currentType,
                    tax_type: 0,
                    class_type: 1,
                }
            };
        } else {
            this.state = {
                isNew: false,
                isLoading: true,
                item: null
            }
        }
    }

    componentDidMount() {
        if (!this.state.isNew) {
            const id = this.props.match.params.id;
            fetch(
                `/api/items/${id}/`,
            )
                .then(res => res.json())
                .then(
                    res =>
                        this.setState(
                            {
                                item: res,
                                isLoading: false
                            }
                        )
                )
        }
    }

    @autobind
    onSubmit(values, {setSubmitting}) {
        setSubmitting(true);
        if (this.state.isNew) {
            this.props.add(values, this.props.history);
        } else {
            this.props.update(values, this.props.history);
        }
    }

    @autobind
    selectItemTemplate(option) {
        if (option.value !== '---') {
            const splits = option.value.split(':');
            const type = splits[0];
            const templateIndex = splits[1];
            const selectedTemplate = itemTemplatesByType[type][templateIndex];
            if (selectedTemplate) {
                const item = this.state.item
                this.setState({item: {...item, ...selectedTemplate}})
                this.dateInput.focus()
            }
        }
    }

    render() {
        if (this.state.isLoading) {
            return <Loading/>
        }
        const itemOptionList = itemTemplatesByType.map(
            (itemTemplates, type) => {
                if (itemTemplates.length > 0)
                    return {
                        label: TYPE_CHOICES[type],
                        options: itemTemplates.map(
                            (template, index) => ({
                                    value: `${type}:${index}`,
                                    label: template.description
                                }))
                    }
            }
        );
        return (
            <Formik
                validationSchema={ItemSchema}
                onSubmit={this.onSubmit}
                initialValues={this.state.item}
                enableReinitialize
            >
                {({isSubmitting}) =>
                    <Form className={'form'}>
                        {this.state.item.type >= 0 &&
                        <FormGroup row>
                            <Col sm={12}>
                                <Label>
                                    Vorlage
                                </Label>
                                <Select
                                    onChange={this.selectItemTemplate}
                                    options={itemOptionList}
                                />
                            </Col>
                        </FormGroup>
                        }
                        <FormGroup row>
                            <Col sm={6}>
                                <Field component={CustomField} type='date' name='date' label='Datum'
                                       innerRef={input => {
                                           this.dateInput = input
                                       }}
                                />
                            </Col>
                            <Col sm={6}>
                                <Field component={CustomField} type='number' step="0.01" name='amount' label='Betrag'
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Field component={CustomField} type='textarea' name='description' label='Beschreibung'/>
                        </FormGroup>
                        <FormGroup row>
                            <Col sm={4}>
                                <Field component={CustomField} type='select' className='form-control' name='type'
                                       label='Typ'>
                                    {
                                        TYPE_CHOICES.map(
                                            (type, id) => <option key={`type_option_${id}`} value={id}>
                                                {type}
                                            </option>
                                        )
                                    }
                                </Field>
                            </Col>
                            <Col sm={4}>
                                <Field component={CustomField} type='select' name='class_type' label='Art'>
                                    {
                                        CLASS_CHOICES.map(
                                            (type, id) => <option key={`class_option_${id}`} value={id}>
                                                {type}
                                            </option>
                                        )
                                    }
                                </Field>
                            </Col>
                            <Col sm={4}>
                                <Field type='select' name='tax_type' component={CustomField} label={'MwSt.'}>
                                    {
                                        TAX_CHOICES.map(
                                            (type, id) => <option key={`tax_option_${id}`} value={id}>
                                                {type}
                                            </option>
                                        )
                                    }
                                </Field>
                            </Col>
                        </FormGroup>
                        <br/>
                        <FormGroup row>
                            <Col sm={3}>
                                <Input type='submit' className='btn-primary' disabled={isSubmitting}
                                       value='Hinzufügen'/>
                            </Col>
                            {!this.state.isNew &&
                            <Col sm={3}>
                                <DeleteItem item={this.state.item}/>
                            </Col>
                            }
                            <Col sm={3} className='offset-3'>
                                <Input type='reset' value='Zurücksetzen'/>
                            </Col>
                            <Col sm={3}>
                                <NavLink className={'btn'} to='/items'> Zurück </NavLink>
                            </Col>
                        </FormGroup>
                    </Form>
                }
            </Formik>
        )
    }
}
